import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Flame } from "lucide-react";
import { api } from "../api";
import { SEO } from "../components/SEO";
import { resolveMediaUrl } from "../components/PageContent";

export default function BadIdeaDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api
      .get(`/bad-ideas/${slug}`)
      .then((r) => setItem(r.data))
      .catch(() => setErr("This bad idea has been redacted."));
  }, [slug]);

  if (err) {
    return (
      <div className="py-24 text-center" data-testid="bad-idea-not-found">
        <SEO title="Bad idea redacted" path={`/bad-ideas/${slug}`} noindex />
        <div className="font-western text-3xl mb-4">{err}</div>
        <Link className="font-mono text-sm underline" to="/bad-ideas">Back to bad ideas</Link>
      </div>
    );
  }
  if (!item) return <div className="py-24 text-center font-mono text-xs uppercase tracking-[0.3em]">Filing the paperwork…</div>;

  return (
    <article className="bg-bone" data-testid="bad-idea-detail-page">
      <SEO
        title={item.title}
        description={item.tagline || item.body?.slice(0, 160)}
        image={item.cover_image}
        type="article"
        path={`/bad-ideas/${item.slug}`}
      />
      <header className="bg-asphalt text-bone py-12">
        <div className="max-w-3xl mx-auto px-5">
          <Link to="/bad-ideas" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] mb-6 hover:text-terra">
            <ArrowLeft className="w-4 h-4" /> Back to bureau
          </Link>
          <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] px-2 py-1 border-2 border-bone mb-4">
            <Flame className="w-3 h-3" /> Risk Level: {item.risk_level}
          </div>
          <h1 className="font-display text-5xl sm:text-6xl uppercase leading-[0.95] tracking-tighter">{item.title}</h1>
          {item.tagline && <p className="font-western text-2xl text-bone/80 mt-3">{item.tagline}</p>}
        </div>
      </header>
      {item.cover_image && (
        <div className="border-y-4 border-asphalt overflow-hidden">
          <img src={resolveMediaUrl(item.cover_image)} alt={item.title} className="w-full max-h-[500px] object-cover ink-stamp" />
        </div>
      )}
      <div className="max-w-3xl mx-auto px-5 py-16">
        <p className="font-body text-lg leading-relaxed whitespace-pre-line text-ink">{item.body}</p>
      </div>
    </article>
  );
}
